import { jsx as _jsx } from "react/jsx-runtime";
import Dropdown from '@hellodarwin/core/lib/components/common/dropdown';
import Tooltip from 'antd/es/tooltip';
import { useMemo } from 'react';
import NavigationMenuLabel from '../../../navigation/menu-item/menu-item-label';
import useHandleLinkClick from '../../../navigation/utils/use-handle-link-click';
import { UserMenuDropdownStyled } from './styles';
import UserMenuButton from './user-menu-button';
const DesktopUserMenu = ({ user, links, notifs, placement = 'bottomRight', compact, sidebar, }) => {
    const handleLinkClick = useHandleLinkClick({ selectedKeys: [] });
    const dropdownItems = useMemo(() => links.map((link) => {
        const isCustomAction = !!link.onClick;
        return {
            key: link.pathname,
            label: (_jsx(NavigationMenuLabel, Object.assign({ handleLinkClick: isCustomAction ? undefined : handleLinkClick }, link, { pathname: isCustomAction ? '' : link.pathname }))),
            onClick: link.onClick,
        };
    }), [links, handleLinkClick]);
    return (_jsx("div", { style: { position: 'relative' }, children: _jsx(Dropdown, { items: dropdownItems, placement: placement, trigger: ['click'], ctaRender: () => {
                var _a;
                return (_jsx(Tooltip, { title: compact ? ((_a = user === null || user === void 0 ? void 0 : user.name) !== null && _a !== void 0 ? _a : user === null || user === void 0 ? void 0 : user.email) : undefined, placement: "right", trigger: ['hover', 'focus'], children: _jsx("div", { children: _jsx(UserMenuButton, { user: user, withArrow: !compact, notifs: notifs, isOnNav: true, compact: compact, sidebar: sidebar }) }) }));
            }, styles: {
                container: Object.assign({ padding: 0 }, (sidebar ? { width: '100%' } : {})),
            }, popupRender: (origin) => (_jsx(UserMenuDropdownStyled, { children: origin })) }) }));
};
export default DesktopUserMenu;
